<template>
  <div class="companyHero">
    <picture>
      <source
        :srcset="getImageSizes('webp')"
        sizes="100vw"
        type="image/webp"
        width=""
        height=""
      />
      <img
        :src="getDefaultImage"
        alt=""
        :srcset="getImageSizes('jpg')"
        sizes="100vw"
      />
    </picture>
  </div>
</template>

<script>
export default {
  name: "CompanyHero",
  props: ["hero"],
  data() {
    return {
      image: {
        sizes: [
          360,
          480,
          720,
          960,
          1024,
          1080,
          1260,
          1440,
          1600,
          1920,
          2048,
          2160,
          2560,
          2880,
          3072,
          3200,
          3780,
          3840,
          4320,
          4800,
          5120,
          5760,
          7680
        ]
      }
    };
  },
  methods: {
    getImageSizes(type) {
      return this.image.sizes
        .map(size => {
          return `/img/hero/${this.hero}-${size}.${type} ${size}w`;
        })
        .join(", ");
    },
    getDefaultImage() {
      return `/img/hero/${this.hero}-360.jpg`;
    }
  }
};
</script>

<style scoped lang="scss"></style>
